import { styled } from '@mui/material/styles';

export const ImageWrapperStyles = styled('div')(() => ({
  margin: 'auto',
  position: 'relative',
  paddingTop: '56.25%',
}));

export const BoxImageStyles = styled('div')(() => ({
  objectFit: 'contain',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
}));
